import { useSearchParams } from 'react-router-dom';

import { CohortBuilderPageTab } from '@verantos-dev/core-enums';

import { DefinitionPageTabContent } from '../../cohort-builder-page-tabs/DefinitionPageTabContent/DefinitionPageTabContent';
import { EventsPageTabContent } from '../../cohort-builder-page-tabs/EventsPageTabContent/EventsPageTabContent';
import { ResearchAssistantTabContent } from '../../cohort-builder-page-tabs/ResearchAssistantTabContent/ResearchAssistantTabContent';
import { ResultsPageTabContent } from '../../cohort-builder-page-tabs/ResultsPageTabContent/ResultsPageTabContent';

export const CohortBuilderPageContent = ({
  isFinalFetchTimerActive,
}: {
  isFinalFetchTimerActive: boolean;
}) => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('pageTab') as CohortBuilderPageTab;

  switch (activeTab) {
    case CohortBuilderPageTab.events:
      return <EventsPageTabContent />;
    case CohortBuilderPageTab.definition:
      return <DefinitionPageTabContent />;
    case CohortBuilderPageTab.results:
      return <ResultsPageTabContent isFinalFetchTimerActive={isFinalFetchTimerActive} />;
    case CohortBuilderPageTab.researchAssistant:
      return <ResearchAssistantTabContent />;
    default:
      return null;
  }
};
